import RegisterInfo from './RegisterInfo';

export default RegisterInfo;
